import React from 'react';

const Footer = () => {
  return (
    <footer className="modern-footer">
      <div className="footer-content">
        <div className="footer-section">
          <div className="footer-brand">
            <div className="brand-icon">C</div>
            <span className="brand-text">Chhatrapal</span>
          </div>
          <p className="footer-description">
            Building exceptional digital experiences with modern technologies, AI integration, and creative solutions.
          </p>
          <div className="footer-made-in">
            <span className="made-text">Made with</span>
            <span className="heart-icon">❤️</span>
            <span className="made-text">in India</span>
            <span className="flag-icon">🇮🇳</span>
          </div>
        </div>

        <div className="footer-section">
          <h4>Services</h4>
          <ul>
            <li>Web Development</li>
            <li>Mobile App Development</li>
            <li>AI Integration</li>
            <li>Full Stack Solutions</li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Technologies</h4>
          <ul>
            <li>React & Next.js</li>
            <li>Node.js & Express</li>
            <li>LangChain & RAG</li>
            <li>AWS & Cloud</li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Let's Connect</h4>
          <div className="footer-social">
            <a href="https://github.com/chhatrapalchoudhaary" title="GitHub">
              <span className="social-icon">⚡</span>
              <span className="social-label">GitHub</span>
            </a>
            <a href="https://www.linkedin.com/in/chhatrapal-choudhary-143a3881/" title="LinkedIn">
              <span className="social-icon">💼</span>
              <span className="social-label">LinkedIn</span>
            </a>
            <a href="https://x.com/web_chhatrapal" title="Twitter">
              <span className="social-icon">🐦</span>
              <span className="social-label">Twitter</span>
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p className="copyright">© 2024 Chhatrapal Choudhary. Be What You Aspire to Be.</p>
          <div className="footer-links">
            <a href="/privacy" className="footer-link">Privacy</a>
            <a href="/terms" className="footer-link">Terms</a>
            <a href="/contact" className="footer-link">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;